// import { Navigate } from 'react-router-dom';

// const PrivateRoute = ({ element: Element }) => {
//   const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
//   // const key = sessionStorage.getItem('key'); // Assuming the token is stored in localStorage
//   const key = localStorage.getItem('key'); // Assuming the token is stored in localStorage

//   return token && key ? <Element /> : <Navigate to="/" />; // Redirect to login if token is missing
// };

// export default PrivateRoute;
import { useKeycloak } from '@react-keycloak/web';

const PrivateRoute = ({ element: Element }) => {
  const { keycloak, initialized } = useKeycloak();

  if (!initialized) {
    return <div>Chargement...</div>;
  }

  if (keycloak.authenticated) {
    return <Element />;
  }
  
  keycloak.login();
  return null; 
};

export default PrivateRoute;